//异常数据
import _import from '@/utils/import'
const Layout = _import('layout/Layout')
let oneCarmulticard = [
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'oneCarmulticard',//办卡量统计
        component: _import('cardMap/oneCarmulticard/index'),
        name: 'oneCarmulticard',
        meta: {
          title: '一车多卡',
          icon: 'widgets',
          keepAlive:false
        }
      },
      {
        path: 'cardDetails',//办卡量统计
        component: _import('cardMap/oneCarmulticard/cardDetails'),
        name: 'cardDetails',
        meta: {
          title: '一车多卡',
          icon: 'widgets'
        }
      },
    ]
  }
]
export default oneCarmulticard;